<template>
    <div>
      <div style="display: flex;" :style="from && from == 'Advanced Search'?'align-items:center':''">
        <Multiselect
            v-model="selectedLabels"
            :options="labelsOptions"
            :multiple="true"
            track-by="_id"
            :close-on-select="true"
            :show-no-results="false"
            deselectLabel=""
            selectLabel=""
            selectedLabel=""
            label="name"
            placeholder="Enter label name"
            :hideSelected="false"
            :showNoOptions="false"
            @open="getLabelNamesFromServer"
            @search-change="getLabelNamesFromServer($event)"
            @remove="removeLabels($event)"
            @select="selectLabels($event)">
            <span slot="noResult">No results</span>
            <span slot="noOptions" style="display:none"></span>
            <div slot="tag" slot-scope="option" class="selected-tags-style" :style="from && from == 'Advanced Search'?'min-height:25px !important;padding-top:2px !important':''">
            <div class="tags-display-style">{{option.option.name}}</div>
                <div class="remove-tag" v-on:click="removeLabels(option.option)">
                    <svg width="2em" height="1.5em" viewBox="0 0 16 16" class="bi bi-x" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
                    </svg>
                </div>
            </div>
            <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
            <input type="checkbox" class="rounded text-light mr-3 bigger-checkboxes" :checked="makeLabelsCheckBoxSelection(scope.option)" @focus.prevent :key="scope.option.name"/>
            <span style="margin-inline-start:12px;">{{ scope.option.name }}</span>
            </div>
        </Multiselect>
        <!-- <browse-icon :wrapcontentwithbutton="true" title="Browse tag(s)" :style="from && from == 'Advanced Search'?'top:0px !important':''" v-on:click.native="isTagBrowse=true"
          class="save-cancel-icon browse-icon"></browse-icon> -->
      </div>
      <!-- <select-tags v-if="isTagBrowse"
              ref="tagsBrowserComponent"
              :selectedTagsFromParent="selectedLabels"
              @saveTagsSelectedFromBrowse="saveTagsSelectedFromBrowse"
              @close='isTagBrowse=false'>
      </select-tags> -->
    </div>
  </template>
  
  <script>
//   import selectLabels from "../tags/TagsBrowse.vue"
  import Multiselect from 'vue-multiselect';
  import {mapActions, mapMutations} from "vuex";
  import {NotifierConstants} from "../../components.constants.js";
//   import BrowseIcon from "../core/InlineBrowseField.vue";
  
  export default {
        props:["selectedTagsList", "selectedLabelsId","componentUUID", "from"],
          data() {
              return {
                  labelsIdList:[],
                  selectedLabels: [],
                  labelsOptions: [],
                  isTagBrowse:false,
              }
          },
          components:{
            //   "browse-icon":BrowseIcon,
            //   "select-tags":selectLabels,
              "Multiselect":Multiselect,
          },
          methods:{
            // getSelectedlabelsIdList(){
            //   console.log("labelsIdListlabelsIdList",this.labelsIdList)
            //   return this.labelsIdList;
            // },
            // saveTagsSelectedFromBrowse(tags){
            //   this.labelsIdList = this.$refs.tagsBrowserComponent.getSelectedlabelsIdList();
            //   this.selectedLabels = tags;
            //   if(typeof this.componentUUID != "undefined"){
            //     this.$emit("updatedBulkTagsList",this.labelsIdList,this.componentUUID);
            //   }else{
            //     this.$emit("updatedBulkTagsList",this.labelsIdList)
            //   }
            //   this.closeTagsBrowse();
            // },
            // closeTagsBrowse(){
            //   this.isTagBrowse = false;
            // },
            getLabelNamesFromServer(value){
              let payload = { params: {}}
              if(value && value.length){
                payload.params = {name:value}
              }
                this.getAllLabelsFromServer(payload).then((data) => {
                    this.labelsOptions = data.labels;
                });
            },
            fetchAndLoadLabelsById(){
                for(let opId of this.labelsIdList){
                    let getInfo = false;
                    if([undefined, null].includes(this.selectedLabels)){
                        getInfo = true;
                    }else{
                        let opIndex = this.selectedLabels.findIndex(e=>e._id == opId);
                        if(opIndex < 0){
                            getInfo = true;
                        }
                    }
                    if(getInfo){
                        let payload = { params: {}}
                        payload.params = {labelId:opId}
                        this.getLabelsInfoFromServer(payload).then((data) => {
                            if(typeof(data) != "undefined" || data.label != null){
                                let labelInfo = data["label"];
                                labelInfo["checked"] = true
                                this.selectedLabels.push(labelInfo)
                            }
                        });
                    }
                }
            },
              selectLabels(option){
               let index = this.labelsOptions.findIndex(item => item._id == option._id);
                   if(index > -1){
                       if([undefined, null].includes(this.labelsIdList)){
                         this.labelsIdList = [option._id];
                       }else if(!this.labelsIdList.includes(option._id)){
                         this.labelsIdList.push(option._id);
                       }
                       this.labelsOptions[index].checked = true;
                       if(typeof this.componentUUID != "undefined"){
                         this.$emit("updatedLabelsList",option,this.componentUUID);
                         return;
                       }
                      this.$emit("updatedLabelsList",option)
                   }
               },
               removeLabels(option){
                   let index = this.selectedLabels.findIndex(item => item._id == option._id);
                   if(index > -1){
                       this.selectedLabels[index].checked = false;
                       if(![undefined, null].includes(this.labelsIdList) && this.labelsIdList.includes(option._id)){
                         this.labelsIdList = this.labelsIdList.filter(e => e != option._id);
                       }
                       this.selectedLabels = this.selectedLabels.filter(e => e._id != option._id)
                       if(typeof this.componentUUID != "undefined"){
                         this.$emit("removedLabelsFromList",option,this.componentUUID);
                         return;
                       }
                      this.$emit("removedLabelsFromList",option)
                   }
               },
               makeLabelsCheckBoxSelection(option){
                   if((this.selectedTagsList != undefined && this.selectedLabels.length) || this.selectedLabels.length){
                       return this.selectedLabels.some((op) => op._id === option._id);
                   }
               },
            //    handleTagNotification(notification){
            //      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
            //      if(notification.message){
            //       if (notification.message_type == NotifierConstants.tagRemovedNotification){
            //         let temp = this.selectedLabels.filter(e => e._id == notification.message._id)
            //         if (temp.length != 0){
            //           this.selectedLabels = this.selectedLabels.filter(e => e._id != notification.message._id)
            //         }
            //       }if(NotifierConstants.tagModifiedNotification == notification.message_type){
            //         let temp = this.selectedLabels.filter(e => e._id == notification.message._id)
            //         if (temp.length != 0){
            //           temp = temp[0]
            //           Object.assign(temp, notification.message)
            //         }
            //       }
            //     }
            //    },
            //   loadAllLabels(){
            //     for(let opId of this.labelsIdList){
            //       let getInfo = false;
            //       if([undefined, null].includes(this.selectedLabels)){
            //         getInfo = true;
            //       }else{
            //         let opIndex = this.selectedLabels.findIndex(e=>e._id == opId);
            //         if(opIndex < 0){
            //           getInfo = true;
            //         }
            //       }
            //       if(getInfo){
            //         let payload = { params: {}}
            //         payload.params = {tagId:opId,filter:JSON.stringify(["name"])}
            //         this.getAllLabelsFromServer(payload).then((data)=>{
            //           if(typeof(data) != "undefined" || data.tag != null){
            //             let tagInfo = data["tag"];
            //             tagInfo["checked"] = true
            //             this.selectedLabels.push(tagInfo)
            //           }
            //         })
            //       }
            //     }
            //   },
               registerforWebsocketNotifications(){
                this.addWSEventListener({
                          eventname:[NotifierConstants.tagRemovedNotification],
                          callback:this.handleTagNotification,
                          parent:"labelsDropdown"})
                },
              unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                          eventname:[NotifierConstants.tagRemovedNotification],
                          callback:this.handleTagNotification,
                          parent:"labelsDropdown"})
                },
              ...mapActions("label", ["getAllLabelsFromServer", "getLabelsAutocomplete","addNewLabel","updateExistingLabel","deleteExistingLabel","getLabelsInfoFromServer"]),
              ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
          },
          watch:{
            selectedTagsList(newVal){
              this.selectedLabels = JSON.parse(JSON.stringify(newVal));
            },
            selectedLabelsId(newVal){
              if(this.from == "Advanced Search"){
                this.selectedLabels = []
                this.labelsIdList = newVal
                this.fetchAndLoadLabelsById();
              }else{
                Object.assign(this.labelsIdList, newVal);
              }
            }
          },
          created(){
             if(this.selectedTagsList != undefined && this.selectedTagsList.length){
                  this.selectedLabels = JSON.parse(JSON.stringify(this.selectedTagsList));
              }
              this.registerforWebsocketNotifications()
              Object.assign(this.labelsIdList, this.selectedLabelsId);
              this.fetchAndLoadLabelsById();
          } ,
          beforeDestroy(){
            this.unRegisterforWebsocketNotifications()
          }
  }
  </script>
  
  
  <style scoped lang="scss">
  $header-background: #1a1a1a;
  $border-color: 1px solid #4a4a4a;
  $background: #121212;
  $background-color-on-hover: #141414;
  $body-background-color: #141414;
  $dull-text-color: #858585;
  $options-text-color: #9c9c9c;
  $icon-color-on-hover: #9c9c9c;
  $text-color: #eee;
  $table-row-border: none;
  $table-border-color:1px solid #141414;
  $active-blue: #007bff;
  $danger-color: #dc3545 !important;
  $input-field-bg-color: #121212;
  $input-field-border-color: #202020;
  $input-field-height:38px;
  $button-height:38px;
  $secondary-border-color: 1px solid #3a3a3a;
  $searchBar-border-color: 1px solid #202020;
  $secondary-text-color: #bbb;
  $modal-border:1px solid #202020;
  $modal-background: #121212;
  $header-color:#9e9e9e;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#141414;
  $scrollbar-thumb-on-hover-background:#555;
  $input-field-padding:.375rem 10px;
  $input-field-and-label-font-size:14px;
  $danger-color: #dc3545 !important;
  $none-text-color:#4f4f4f;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $active-green-color:#28a745;
  $breadcrumb-background:#181818;
  $mutliselect-tag-bg-color:#0a0a0a;
  $mutliselect-all-tags-bg-color:#161616;
  $multiselect-option-highlight-bg-color:#242424;
  $multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
  $learn-about-text-color:#e8912d;
  $close-icon-bg-on-hover:#3a3a3a;
  $svg-color:#9e9e9e;
  $tags-background-color:#272727;
  $tags-border-color:#363636;
  $multiselect-tag-border-color:#292929;
  $metadata-border-color:#303030;
  $metadata-border-color-on-hover: #5a5a5a;
  $metadata-field-bg-color: #1d1d1d;
  
  .all-users-selection:hover{
    background: $multiselect-tag-on-focus-or-hover-bg-color;
  }
  .selected-tags-style{
    background: $tags-background-color;
    border: 1px solid $tags-border-color;
    border-radius: 15px;
    font-size: 12px !important;
    min-height: 30px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px !important;
    text-align: center;
    width: auto !important;
    padding-inline-start: 12px !important;
    justify-content: center;
    padding-top: 4px !important;
    padding-inline-end: 4px !important;
    .remove-tag{
      line-height:18px;
    }
  }
  
  .bigger-checkboxes {
      height: 30px;
      width: 20px;
      position:relative;
  }
  input[type="checkbox"]:after {
      line-height: 1.5em;
      content: "";
      display: inline-block !important;
      width: 22px !important;
      height: 21px !important;
      margin-top: 5px !important;
      margin-inline-start: -1px !important;
      border: $border-color !important;
      border-radius: 0.25em !important;
      background: $body-background-color !important;
  }
  input[type="checkbox"]:checked:after {
      content: "✔";
      color: $active-blue !important;
      position: absolute !important;
      font-size: 16px !important;
      line-height: 1 !important;
      transition: all 0.2s !important;
      font-family: Helvetica, Arial, sans-serif;
      padding-inline-start: 4px !important;
      padding-top: 2px !important;
  }
  
  .user-name-or-image{
      height: 30px;
      width: 30px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: 28px;
      text-transform: uppercase;
      margin-top: 3px;
      margin-inline-end: 5px;
  }
  ::v-deep{
    .multiselect {
      margin: 3px 0px;
    }
    .multiselect__content-wrapper {
      display: none;
    }
    .multiselect__tag, .tags-style {
      background-color: $mutliselect-tag-bg-color !important;
      border: $border-color !important;
      border-radius: 5px;
    }
    .multiselect__tags, .tags-style {
      background: $mutliselect-all-tags-bg-color !important;
      border: $border-color !important;
    }
    .multiselect__option--highlight {
      background: $multiselect-option-highlight-bg-color !important;
    }
    .multiselect__content {
      background: $header-background !important;
    }
    .multiselect__input,
    .multiselect__single {
      background: transparent !important;
      color: $text-color;
    }
    .multiselect__input:focus {
      outline: none;
      box-shadow: none;
    }
    
    .multiselect__tag-icon {
      color: $text-color !important;
      inset-inline-end: 2px !important;
    }
    .multiselect__tag-icon:focus,
    .multiselect__tag-icon:hover {
      background: $multiselect-tag-on-focus-or-hover-bg-color !important;
      color: $text-color !important;
    }
    .multiselect__tag-icon:after {
      color: $icon-color-on-hover !important;
      font-size: 20px !important;
    }
  
    .multiselect * {
      font-size: $input-field-and-label-font-size !important;
      font-family: "Roboto", Arial, sans-serif !important;
    }
    .multiselect__placeholder {
      padding-top: 3px;
    }
    .multiselect {
      color: $text-color !important;
      font-size: $input-field-and-label-font-size !important;
      width: 40%;
      min-height: 38px;
    }
    .multiselect__single {
      padding-top: 3px;
    }
    .multiselect__option--selected {
      background: $multiselect-option-highlight-bg-color !important;
      color: $text-color;
    }
    .multiselect__content-wrapper {
      border: 1px solid $multiselect-option-highlight-bg-color !important;
      position: absolute;
      display: block;
      background: $text-color;
      width: 100%;
      max-height: 240px;
      overflow: auto;
      border: 1px solid $text-color;
      border-top: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      z-index: 50;
      -webkit-overflow-scrolling: touch;
    }
  
    .multiselect__current,
    .multiselect__option {
      line-height: 12px !important;
    }
  
    .multiselect__select{
      display:none;
    }
    .multiselect--above .multiselect__content-wrapper {
      background: $header-background !important;
    }
    .multiselect__tags {
      background: $background !important;
      height: auto;
      min-height: 45px !important;
      padding: 11px 40px 0 8px;
      border: $border-color !important;
    }
  }
  
  .table td, .table th {
      border-top: none;
      padding:0px;
  }
  
  .display-as-tags{
      display: inline-flex;
      flex-wrap: wrap;
      justify-content: start;
      float: inline-start;
  }
  
  .select-catalog-field{
      width: 101%;
      .value-style{
        width:100%;
      }
  }
  
  .user-name-or-image {
    height: 30px;
    width: 30px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 28px;
    text-transform: uppercase;
    margin-top: 3px;
    margin-inline-start: 5px;
  }
  
  .user-name-or-image-in-selected-option{
    border: 1px solid #3a3a3a;
  height: 26px;
  width: 26px;
  border-radius: 5px;
  text-align: center;
  line-height: 26px;
  text-transform: uppercase;
  margin-top: -1px;
  margin-inline-start: -1px;
  }
  
  .tags-style{
      display: inline-flex;
      margin-inline-end: 5px;
      margin-bottom: 2px;
      height: 27px;
      margin-inline-start: 3px;
    .user-name-display-as-tags{
        line-height: 27px;
        margin-inline-start: 6px;
    }
  }
  
  .remove-tag{
    color:$dull-text-color;
    line-height: 25px;
  }
  
  .remove-tag:hover{
    color:$text-color;
  }
  
  .save-cancel-icon{
    position:relative;
    top:10px;
    inset-inline-start:5px;
    color:$text-color;
  }
  .browse-icon{
    color:$svg-color !important;
  }
  .browse-icon{
      position: relative;
      inset-inline-start:8px;
      top: 9px;
  }
  </style>